import {
  WSElement,
  WSElementProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { IBankAccount } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { InfoRow } from "../InfoRow/InfoRow";

type Props = {
  bankTransferInfo?: IBankAccount;
  internationalBankTransferInfo?: IBankAccount;
  invoiceNumber?: string;
} & WSElementProps;

export const ManualWireTransferDetails: React.FC<Props> = ({
  bankTransferInfo,
  internationalBankTransferInfo,
  invoiceNumber,
  ...elementProps
}) => {
  const bankName = bankTransferInfo?.bankName;
  const routingNumber = bankTransferInfo?.routingNumber;
  const accountNumber = bankTransferInfo?.accountNumber;

  return (
    <WSElement {...elementProps}>
      <WSText weight="medium" mb="XL">
        US bank wire details
      </WSText>

      <InfoRow label="Bank name" value={bankName || "N/A"} longName />
      {routingNumber && (
        <InfoRow label="Routing" value={routingNumber} longName mt="M" />
      )}
      <InfoRow label="Account" value={accountNumber || "N/A"} longName mt="M" />
      {invoiceNumber && (
        <InfoRow
          mt="M"
          label="Note/memo"
          value={`Invoice #${invoiceNumber}`}
          longName
        />
      )}
    </WSElement>
  );
};
